
import { defineComponent } from 'vue'
import { setInputDataType, getInputStep, formatRegistryNumber } from '@/helpers/commons/tableHelpers'
import { formatDate, getLocale } from '@/helpers/commons/localeHelper'
import { luxonFormatDate, primeVueDate } from '@/helpers/commons/localeHelper'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'
import registryDatatableDescriptor from './RegistryDatatableDescriptor.json'
import deepcopy from 'deepcopy'

export default defineComponent({
    name: 'registry-datatable-editable-field',
    components: { Calendar, Dropdown, InputNumber },
    props: {
        column: { type: Object },
        propRow: { type: Object },
        comboColumnOptions: { type: Array }
    },
    emits: ['rowChanged', 'dropdownChanged', 'dropdownOpened'],
    data() {
        return {
            registryDatatableDescriptor,
            row: {} as any,
            columnOptions: [] as any[],
            options: [] as any[],
            useGrouping: false,
            locale: '',
            minFractionDigits: 2,
            maxFractionDigits: 2
        }
    },
    watch: {
        propRow() {
            this.loadRow()
        },
        comboColumnOptions: {
            handler() {
                this.loadColumnOptions()
            },
            deep: true
        }
    },
    created() {
        this.setDefaultLocale()
        this.loadRow()
        this.loadColumnOptions()
    },
    computed: {
        getCurrentLocaleDefaultDateFormat() {
            return (column) => column.format || primeVueDate()
        }
    },
    methods: {
        loadRow() {
            this.row = deepcopy(this.propRow)
            if (this.column && (this.row[this.column.field] || this.row[this.column.field] === 0 || this.row[this.column.field] === '')) {
                if (this.column.columnInfo?.type === 'date' && typeof this.row[this.column.field] === 'string') {
                    this.row[this.column.field] = this.row[this.column.field] ? new Date(luxonFormatDate(this.row[this.column.field], 'yyyy-MM-dd', 'yyyy-MM-dd')) : null
                } else if (this.column.columnInfo?.type === 'timestamp' && typeof this.row[this.column.field] === 'string' && this.row[this.column.field] !== '') {
                    this.row[this.column.field] = new Date(luxonFormatDate(this.row[this.column.field], 'yyyy-MM-dd HH:mm:ss.S', 'yyyy-MM-dd HH:mm:ss.S'))
                } else if (this.column.editorType !== 'COMBO' && this.column.columnInfo?.type !== 'date' && this.column.columnInfo?.type !== 'timestamp' && this.getDataType(this.column.columnInfo?.type) === 'number') {
                    this.formatNumberConfiguration()
                }
            }
        },
        formatNumberConfiguration() {
            const configuration = formatRegistryNumber(this.column)
            if (configuration) {
                this.useGrouping = configuration.useGrouping
                this.minFractionDigits = configuration.minFractionDigits
                this.maxFractionDigits = configuration.maxFractionDigits
            }
        },
        setDefaultLocale() {
            const locale = getLocale()
            this.locale = locale ? locale.replace('_', '-') : ''
        },
        getDataType(columnType: string) {
            return setInputDataType(columnType)
        },
        getStep(dataType: string) {
            return getInputStep(dataType)
        },
        loadColumnOptions() {
            this.columnOptions = this.comboColumnOptions as any[]
        },
        getFormattedDate(date: any, format: any, incomingFormat?: string) {
            return formatDate(date, format, incomingFormat)
        },
        updateChangedRow() {
            setTimeout(() => this.$emit('rowChanged', this.row), 250)
        },
        onInputNumberChange() {
            this.updateChangedRow()
        },
        getOptions(column: any, row: any) {
            let options = this.columnOptions && this.columnOptions[column.field] ? this.columnOptions[column.field][row[column.dependences]] : []
            if (!options || options.length === 0) options = this.columnOptions[column.field]['All']
            return options ?? []
        }
    }
})
